import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Colors, FontSize } from '../../../assets';
import { useUser } from '../../../common/components/Header/useUser';

const WelcomeContainer = styled.div`
  background: linear-gradient(135deg, ${Colors.primary} 0%, ${Colors.secondary} 100%);
  border-radius: 16px;
  padding: 2rem 2.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const WelcomeContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const WelcomeTitle = styled.h1`
  color: ${Colors.white};
  font-size: ${FontSize.logo};
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  letter-spacing: -0.5px;
`;

const WelcomeSubtitle = styled.p`
  color: ${Colors.lightText};
  font-size: ${FontSize.subTitle};
  margin: 0;
  font-weight: 300;
`;

const WelcomeTime = styled.div`
  color: ${Colors.white};
  font-size: 48px;
  font-weight: 700;
  letter-spacing: -1px;
  text-align: right;
`;

const BlinkingColon = styled.span<{ $show: boolean }>`
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  transition: opacity 0.1s ease;
`;

export const WelcomeSection: React.FC = () => {
  const user = useUser();
  const [currentTime, setCurrentTime] = useState(new Date());
  const [showColon, setShowColon] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
      setShowColon((prev) => !prev);
    }, 1000); // Update every second

    return () => clearInterval(timer);
  }, []);

  const formattedDate = currentTime.toLocaleDateString('cs-CZ', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const hours = currentTime.toLocaleTimeString('cs-CZ', {
    hour: '2-digit',
    minute: '2-digit'
  });

  const [hourPart, minutePart] = hours.split(':');

  return (
    <WelcomeContainer>
      <WelcomeContent>
        <WelcomeTitle>{user?.first_name && user?.last_name ? `${user.first_name} ${user.last_name}` : user?.username}, vítejte v iPitva</WelcomeTitle>
        <WelcomeSubtitle>{formattedDate}</WelcomeSubtitle>
      </WelcomeContent>
      <WelcomeTime>
        {hourPart}
        <BlinkingColon $show={showColon}>:</BlinkingColon>
        {minutePart}
      </WelcomeTime>
    </WelcomeContainer>
  );
};
